enum SharedBlock {
  CLIENTS = 'shared-blocks.block-clients',
  COMPLETED_PROJECTS = 'shared-blocks.block-completed-projects',
  CONSULTATION = 'shared-blocks.block-consultation',
  CONTACTS = 'shared-blocks.contacts',
  CONTENT_ITEMS = 'shared-blocks.block-content-items',
  CUSTOMER_FORM = 'shared-blocks.customer-form',
  WYSIWYG_CONTENT = 'shared-blocks.wysiwyg-content',
  FAQ = 'shared-blocks.faq',
  HOW_WE_WORK = 'shared-blocks.block-how-we-work',
  MAP = 'shared-blocks.block-map',
  NEWS_ARTICLES = 'shared-blocks.news-and-articles',
  OTHER_ITEMS = 'shared-blocks.block-other-items',
  PAGE_HEADING = 'blockHeading',
  PRICE_TABLE = 'shared-blocks.block-price-table',
  TITLE_TEXT_IMAGE = 'shared-blocks.block-title-text-image',
  TITLE_TEXT_IMAGE_BUTTON = 'shared-blocks.block-title-text-image-button',
}
export default SharedBlock;
